<template lang="html">
  <button :aria-label="label" class="button" :class="{ disabled, icon }" :disabled="disabled"><slot /></button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    icon: Boolean,
    label: String,
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'

.button
  padding: 11px 24px
  margin: 0 auto
  background-color: $text
  color: $default-dark
  border: none
  font-family: 'Poppins', 'Montserrat', 'Inter', sans-serif
  font-size: 1rem
  font-weight: 600
  text-transform: uppercase
  letter-spacing: 1px
  height: 48px
  border-radius: 24px
  text-shadow: 0 1px rgba(0,0,0,0.25)
  box-shadow: 0 4px 12px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.1)

  &:active
    transform: translateY(2px);

  &.icon
    padding: 9px
    height: 36px
    width: @height
    line-height: 18px
    vertical-align: top

  &:disabled
    opacity: 0.5
    box-shadow: none

    &:active
      transform: none

</style>
